module.exports = __webpack_public_path__ + "static/media/people-icon.db1f7b20.svg";


//////////////////
// WEBPACK FOOTER
// ./public/img/people-icon.svg
// module id = 840
// module chunks = 0 1